<template>
  <div class="c-main-container">

    <div class="title-container">
      <img src="/images/kodomopay_logo.png">
    </div>
    <BackLink :to="backTo"/>

    <div class="content-container">
      <div class="header">使い方</div>
      <div class="inner">

        <div class="item">
          <div class="question-container">
            <div class="head">Q</div>
            <div class="contents">
              こどもペイって？
            </div>
          </div>
          <div class="answer-container">
            <div class="head">A</div>
            <div class="contents">
              こどもたちの頑張りを見える化します。<br>
              ペイは自由に発行する事ができます。<br>
              本サービス内のペイはアプリ内のみで使えるポイントです。<br>
              ※本サービスのペイは現金やその他ペイメントサービスに交換、換金する事はできません。<br>
              ※本サービスのペイを実際の商品などに交換するサービスではありません。<br>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="question-container">
            <div class="head">Q</div>
            <div class="contents">
              有料のサービスですか？
            </div>
          </div>
          <div class="answer-container">
            <div class="head">A</div>
            <div class="contents">
              こどもペイは無料のサービスです。<br>
              ※サイト内に広告が表示されます
            </div>
          </div>
        </div>

        <div class="item">
          <div class="question-container">
            <div class="head">Q</div>
            <div class="contents">
              キッズ専用ページにも広告が表示されますか？
            </div>
          </div>
          <div class="answer-container">
            <div class="head">A</div>
            <div class="contents">
              キッズ専用ページには広告は表示されないので、安心してお使いいただけます。<br>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="question-container">
            <div class="head">Q</div>
            <div class="contents">
              ペイを使うには？
            </div>
          </div>
          <div class="answer-container">
            <div class="head">A</div>
            <div class="contents">
              貯めたペイをつかって、<br>
              ・30分ゲームをする<br>
              ・お菓子やマンガを買える<br>
              ・テーマパークにお出かけする<br>
              など、こども達のご褒美としてご自由にお使いください。<br>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="question-container">
            <div class="head">Q</div>
            <div class="contents">
              登録方法は？
            </div>
          </div>
          <div class="answer-container">
            <div class="head">A</div>
            <div class="contents">
              メールアドレスで簡単に登録することができます。
            </div>
          </div>
        </div>


        <div class="item">
          <div class="question-container">
            <div class="head">Q</div>
            <div class="contents">
              使い方をおしえてください
            </div>
          </div>
          <div class="answer-container">
            <div class="head">A</div>
            <div class="contents">
              ■ キッズを登録<br>
              まずはキッズを登録しましょう。<br>
              <br>
              ■ ペイをあげる<br>
              自由にペイを付与する事ができます。<br>
              <br>
              ■ ペイをつかう<br>
              自由にペイを消費する事ができます。<br>
              残高がない場合はマイナスとなります。<br>
              <br>
              ■ お約束とご褒美を決める<br>
              ペイを貯める、使う為のお約束とご褒美を設定することができます<br>
              設定しておくと、簡単にペイを付与したり使ったりできます。
            </div>
          </div>
        </div>

        <div class="item">
          <div class="question-container">
            <div class="head">Q</div>
            <div class="contents">
              どのような使い方ができますか？
            </div>
          </div>
          <div class="answer-container">
            <div class="head">A</div>
            <div class="contents">
              ■ ホーム
              <div class="image-container">
                <img src="/images/kodomopay_image1.png" class="how-to-image">
              </div>
              <div class="detail">
                キッズが2人以上登録されている場合には、お約束、ご褒美のペイをまとめて"あげる"・"使う"ことができます。
              </div>

              ■ ペイをあげる/使う
              <div class="image-container">
                <img src="/images/kodomopay_image2.png" class="how-to-image">
              </div>

              ■ キッズ専用ページ
              <div class="image-container">
                <img src="/images/kodomopay_image3.png" class="how-to-image">
              </div>
              <div class="detail">
                QRコードから、キッズ専用ページに行くことができます。<br>
                キッズ専用ページはログイン不要なので、お子様がお使いのタブレットなどでホームアイコンを追加したり、ブックマークしておくと、便利です！
              </div>

            </div>
          </div>
        </div>

        <hr class="hr">

        <div class="home-icon-container-header">
          <span>
            <i class="fal fa-info-circle"></i> ホーム画面にアイコンを追加しよう！
          </span>
        </div>
        <div class="home-icon-container">
          safariの場合<br>
          <div class="tACenter">・真ん中のアイコンをタップ</div>
          <img src="/images/home_icon1.png" class="img">
          <br>
          <div class="tACenter">・「ホーム画面に追加」を選ぶ</div>
          <img src="/images/home_icon2.png" class="img">
        </div>

      </div>
    </div>

    <AdSense/>

  </div>
</template>

<script>
import BackLink from '@/components/project/BackLink';
import AdSense from '@/components/project/AdSense';

export default {
  props: ['to'],
  components: {
    BackLink,
    AdSense
  },
  computed: {
    backTo: function () {

      let userId = this.$store.getters['auth/userId'];
      console.log(userId);

      if (userId >= 1) {
        return {name: 'Home'};
      } else {
        return {name: 'Welcome'};
      }

    }
  }
};

</script>

<style lang="scss" scoped>

  .content-container {
    margin: 10px;

    .header {
      font-size: 18px;
      padding-bottom: 5px;
      border-bottom: 1px solid #ddd;
    }

    .inner {

      .item {
        font-size: 14px;
      }
    }
  }

  .question-container {
    display: flex;
    line-height: 50px;

    .head {
      flex-shrink: 0;
      flex-basis: 50px;
      color: #78ACD7;
      padding-left: 13px;
      font-weight: bold;
      font-size: 16px;
    }

    .contents {
      font-weight: bold;
      flex-grow: 1;
    }
  }

  .answer-container {
    display: flex;
    background: #FCFCFC;
    padding-top: 10px;
    padding-bottom: 15px;
    border-top: 2px solid #eee;
    border-bottom: 2px solid #eee;

    .head {
      flex-shrink: 0;
      flex-basis: 50px;
      color: #F8AB1E;
      line-height: 25px;
      padding-left: 13px;
      font-size: 16px;
      font-weight: bold;

    }

    .contents {
      line-height: 25px;
    }
  }

  .hr{
    margin-top: 20px;
    margin-bottom: 10px;
    border: 0 solid #ddd;
    border-top-width: 1px;
  }

  .title-container {

    text-align: center;

    img {
      height: 40px;
    }
  }

  .home-icon-container-header {
    margin-bottom: 5px;
  }

  .detail {
    font-size: 13px;
    margin-bottom: 10px;
  }

  // 801以上
  @media screen and (min-width: 801px) {
    .image-container {
      text-align: center;
      width: 250px;
      margin: 20px;
      border: 1px solid #ddd;
      border-radius: 6px;
      padding: 10px;

      img {
        width: 90%;
      }
    }

    .home-icon-container {
      border: 1px solid #ddd;
      border-radius: 6px;
      padding: 10px;

      .img {
        display: block;
        margin: 0 auto;
        width: 250px;
      }
    }
  }

  // 800まで
  @media screen and (max-width: 800px) {
    .image-container {
      text-align: center;
      width: 50%;
      margin: 20px auto;
      border: 1px solid #ddd;
      border-radius: 6px;
      padding: 10px;
      font-size: 14px;

      img {
        width: 100%;
      }
    }

    .home-icon-container {
      border: 1px solid #ddd;
      border-radius: 6px;
      padding: 10px;

      .img {
        display: block;
        margin: 0 auto;
        width: 70%;
      }
    }
  }


</style>
